export default __webpack_public_path__ + "static/media/unselected2.f091c3e1.png";